<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Expiration de session</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">Votre session est sur le point d'expirer</p>

            <app-count-down [expirationDate]="data.sessionTimeout" [options]="countDownOptions" (finished)="onFinished($event)"></app-count-down>

            <p class="question">Voulez-vous poursuivre votre session ?</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="close()">Non</button>
        <button mat-raised-button class="accent-button" (click)="extend()">Oui</button>
    </mat-card-actions>
</mat-card>
